import React from "react";
import { toString } from 'lodash';
import { FixedForm } from "../../components/Forms";
import { Flex } from "../../components/Flex";
import { Title } from "../../components/Text";
import { ActionFormItem } from "../forms/ActionFormItem";
import { snakeCase } from "../../utils";
import { Button } from "../../components/Button";
import { Scrollbar } from "../../components/Scrollbar";
import { createPortal } from "react-dom";


const FiltersPanel = ({ visible, searchOptions=[], selectedOptions={}, setQueryParams, onClose }) => {
    return(visible
        ? createPortal(
            <FixedForm isForm={false} width="420px" onClose={onClose} gap={{ bottom: 20 }}>
                <Title h4>Filters</Title>
                <Flex flex={1} direction="column">
                    <Scrollbar>
                    <Flex direction="column" gap={{ bottom: 20 }} padding={{ right: "20px" }}>
                        {searchOptions.map(option => (
                            option.key && <ActionFormItem
                                key={`filter-panel-item-${option.key}`}
                                type={option.type == "boolean" ? "select" : option.type}
                                label={option.title}
                                mode={option.multiple ? "multiple" : null}
                                name={option.key}
                                options={option.options ? option.options.map(o => ({ ...o, key: snakeCase(o.key) })) : null}
                                onValueChange={(name, value) => setQueryParams({ [name]: option.type == "checkbox" && value == 0 ? null : option.type !== "select" && value !== null ? Number(value) : value, page: 1 })}
                                value={option.type === "boolean" && selectedOptions[option.key] !== null ? toString(selectedOptions[option.key]) : selectedOptions[option.key]}
                            />
                        ))}
                    </Flex>
                    </Scrollbar>
                </Flex>
                <Flex justify="flex-end">
                    <Button onClick={() => onClose()} >Close</Button>
                </Flex>
            </FixedForm>,
            document.getElementById("sp-app-layout")
        )
        : null
    )
};

export { FiltersPanel };